<ng-container *ngFor="let message of _Alert.Messages">
    <div [class]="message.style + ' alert'" *ngIf="message">
        <p [innerHTML]="message.content"></p>
        <button mat-icon-button class="delete" (click)="_Alert.dismissMessage(message.id)">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
</ng-container>
